// src/pages/VoucherEdit.jsx
import React, { useEffect, useRef, useState } from "react";
import SideBar from "../../commun/SideBar";
import Hearder from "../../commun/Hearder";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const VoucherEdit = () => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);

  const initialHTML = `
 <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Booking Voucher</title>

    <!-- Fonts and icons -->
    <script src="../assets/js/plugin/webfont/webfont.min.js"></script>
    <script>
      WebFont.load({
        google: { families: ["Public Sans:300,400,500,600,700"] },
        custom: {
          families: [
            "Font Awesome 5 Solid",
            "Font Awesome 5 Regular",
            "Font Awesome 5 Brands",
            "simple-line-icons",
          ],
          urls: ["../assets/css/fonts.min.css"],
        },
        active: function () {
          sessionStorage.fonts = true;
        },
      });
    </script>


    <!-- CSS Files -->
    <link rel="stylesheet" href="../assets/css//bootstrap.min.css" />
    <link rel="stylesheet" href="../assets/css/plugins.min.css" />
    <link rel="stylesheet" href="../assets/css/kaiadmin.min.css" />

    <!-- Animate.css -->
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"/>

    <!-- CSS Just for demo purpose, don't include it in your project -->
    <link rel="stylesheet" href="../assets/css/demo.css" />
</head>
<style>
     .bullet-dote-container{
         width: 10px;
         height: 10px ;
         border-radius: 50% ;
         border: 3px solid #8b949a ;
         display: flex ;
         align-items: center ;
         justify-content: center ;
         margin-top: 5px;
        }
        .bullet-dote-box{
            width: 5px ;
            height: 5px ;
            border-radius: 50% ; 
            background-color: white ; 
        }
</style>
<body>
   <div id="voucher-content" class="text-muted" style= "font-size: 12px;" >
        <div class="bg-white p-4">
          <!-- Header -->
          <div class="text-center  mb-1">
            <img
              src="/assets/img/uday-golden_logo.jpg"
              alt="Uday Palace Logo"
              style=" height: auto ; width: 50% " 
              class="me-3"
            />
          </div>


          <!-- Hotel Image --> 

          <img
            src="/assets/img/facade-image-1.jpg"
            alt="Hotel"
            class="rounded-lg shadow-md "
            style=" width: 100% ; height: 500px; "
          />
          <h1 class="mt-2 fw-800" style=" color: #9b5c0d " > Your Booking is Confirmed! </h1>
          <hr />
          <!-- <p class="fw-bold" >Booking ID - <span class="font-mono">{BookingID.BONRESID || "N/A"}</span></p> -->

          <!-- Booking Details -->
          <div class="row">
            <div class="col-md-6">
              <p class="mb-4">
                Dear <strong>{{Title}} {{FirstName}} {{LastName}} </strong>,
              </p>
              <div>
                Thank you for choosing 
                <strong>{{DisplayName}},</strong>
              </div>
              <div>
                for your upcoming stay.<br/>
                Your booking is confirmed, there’s no need to reconfirm with the
                hotel or <strong>BookOnNILE</strong>.
              </div>
              <div>
                We look forward to welcoming you and wish you a pleasant visit.
              </div>


             <div class="row mt-1" >
                <div class="col-md-7">
                  <div class="text-start"><b>Bank Name:</b> {{BranchName}}</div>
                </div>
                
              </div>
               <div class="row mt-1" >
                <div class="col-md-7">
                  <div class="text-start"> <b>Account name:</b> {{AccountHoldername}}</div>
                </div>
               
              </div>
               <div class="row mt-1" >
                <div class="col-md-7">
                  <div class="text-start"> <b>Account no:</b> {{Accountno}}</div>
                </div>
              
              </div>
              <div class="row mt-1" >
                <div class="col-md-12">
                  <div class="text-start"><b>IFSC Code :</b> {{IFSCCode}}</div>
                </div>
                
              </div>               

              <div class="row" >
                <div class="col-md-12">
                  <div class="text-start"><b>Company name :</b> {{Reg_CompName}}</div>
                </div>
                             
              </div>
              <div class="row" >
                <div class="col-md-12">
                  <div class="text-start"> <b>Company Address :</b> {{RegCom_Address}}</div>
                </div>
                
              </div>
              <div class="row" >
                <div class="col-md-12">
                  <div class="text-start"><b>Comapany No :</b> {{RegTax_Number}}</div>
                </div>
              </div>

            </div>
            

             
            <div class="col-md-1"></div>

            <!-- Right - Note -->
            <div class="col-md-5">
              <h6 class="fw-bold" style=" color: #9b5c0d "> HERE ARE YOUR BOOKING DETAILS: </h6>
              <div class="row" style=" border-bottom: 1px solid #D4D3D3 ">
                <div class="col-md-7">
                  <div class="text-start">Confirmation No.</div>
                </div>
                <div class="col-md-5">
                  <div >{{PMSRESID}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3 ">
                <div class="col-md-7">
                  <div class="text-start">Guest Name</div>
                </div>
                <div class="col-md-5">
                  <div > {{FirstName}} {{LastName}} </div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3 ">
                <div class="col-md-7">
                  <div class="text-start">Booking Date</div>
                </div>
                <div class="col-md-5">
                  <div >{{BookingDate}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Room Type</div>
                </div>
                <div class="col-md-5">
                  <div >{{RoomName}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Meal Plan</div>
                </div>
                <div class="col-md-5">
                  <div >{{MealPlan}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Check-In</div>
                </div>
                <div class="col-md-5">
                  <div >{{CheckInDate}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Check-Out</div>
                </div>
                <div class="col-md-5">
                  <div >{{CheckOutDate}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Total Night</div>
                </div>
                <div class="col-md-5">
                  <div >{{Nights}}</div>
                </div>
              </div>

               <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Total room</div>
                </div>
                <div class="col-md-5">
                  <div >{{TotalRoom}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">No. of Guest</div>
                </div>
                <div class="col-md-5">
                  <div >{{Guests}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Room Rate (Per Night)</div>
                </div>
                <div class="col-md-5">
                  <div >₹ {{RoomRate}}</div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Extra Charges(if any)</div>
                </div>
                <div class="col-md-5">
                  <div ></div>
                </div>
              </div>

              <div class="row" style=" border-bottom: 1px solid #D4D3D3">
                <div class="col-md-7">
                  <div class="text-start">Total Amount</div>
                </div>
                <div class="col-md-5">
                  <div >₹ {{TotalAfterTax}}</div>
                </div>
              </div>

             

            </div>
          </div>

          <div class="row">
                <div class="col-md-12">
                  <div>Notes : {{BookingComment}} </div>
                </div>
              </div>

               <div class="row">
                <div class="col-md-12">
                  <div>Payment Notes : {{PaymentComment}} </div>
                </div>
              </div>

          <!-- Footer -->
          <div class="mt-3">
            Accommodation charges collected on behalf of hotel (incl. applicable
            taxes).

          </div>
        </div>

        <div class="page-break"></div>

        <div class="d-flex" style=" margin-top: -87px ">
          <div
            style=" display: flex ;  flex-direction: column ; flex: 0.9 "
          >
            <img
              src="/assets/img/BHA_1093.jpg"
              alt="Restaurant"
              style=" width: 100%;  height: 150px; display: block; "
            />
            <img
              src="/assets/img/BHA_0930-.jpg"
              alt="Swimming Pool"
              style=" width: 100%; height: 150px; display: block; "
            />
          </div>

          <!-- Right Column (big image) -->
          <div style=" flex: 1.1 ">
            <img
              src="/assets/img/BHA_0798.jpg"
              alt="Hotel Room"
              style="
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
              "
            />
          </div>
        </div>

        <!-- TERMS & CONDITIONS + PLACES TO EXPLORE -->
        <div class="p-4 mt-1">
          <div class="row">
            <!-- Terms & Conditions -->
            <div class="col-md-6">
               <div style="text-align: justify;">
              <div> <h5 class="fw-bold mb-2" style=" color: #9b5c0d ">TERMS & CONDITIONS</h5>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container ">
                    <div class="bullet-dote-box"></div>
                  </div>
                  Check-in: 1400 hrs; Check-out: 1200 hrs.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Early check-in and late check-out subject to availability; applicable charges as per policy.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>ForgGuaranteed early check-in/late check-out, advance payment is required.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Cancellations must be made at least 48 hrs prior to arrival.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Failure to cancel on time or no-show will attract one-day retention charges.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>All guest must present valid goverment-approved photo ID(Aadhar, Driving License, voter ID, Passport).PAN card is not accepted as ID</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Foreign nationals must present valid password and visa.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Local guests & unmarried couples not allowed as per hotel policy.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Room tariff is per room er night; taxes and service charges extra.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Transfers not included but can arranged on a chargeable basis</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>All bills must be settled directly at check-out.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Special request are not guaranteed.</div>
                <div class="d-flex gap-2 p-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>Signing facility only for approved corporate account.</div>
</div>
              </div>
            </div>




            <div class="col-md-1"></div>

            <!-- Places to Explore -->
            <div class="col-md-5">
              <h5 class="fw-bold mb-2" style=" color: #9b5c0d ">
                PLACES TO EXPLORE
              </h5>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div>Dandi Beach</div></div>
                <div class="col-sm-3">
                  <div>23.9 KM</div></div>
              </div>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">National Salt Satyagrah Memorial</div>
                <div class="col-sm-3">25.6 KM</div>
              </div>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">First Dastoor Meherjirana Library</div>
                <div class="col-sm-3">8.6 KM</div>
              </div>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">Desai Atash Behram</div>
                <div class="col-sm-3">8.7 KM</div>
              </div>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">Jamshed Baug Navsari</div>
                <div class="col-sm-3">7.5 KM</div>
              </div>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">BAPS Shri Swaminarayan Temple</div>
                <div class="col-sm-3">9.1 KM</div>
              </div>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">Andheshwar Mahadev Temple</div>
                <div class="col-sm-3">10.7 KM</div>
              </div>
              <div class="row p-1">
                <div class="col-sm-1">
                  <div class="bullet-dote-container">
                    <div class="bullet-dote-box"></div>
                  </div>
                </div>
                <div class="col-sm-8">Unai Mata Temple</div>
                <div class="col-sm-3">55.7 KM</div>
              </div>

              <img
                src="/assets/img/examples/example11.jpeg"
                alt="Places to Explore"
                class="mt-4"
                style=" width: 100%; height: 200px; object-fit: cover; "
              />
            </div>

          </div>

          <div class="text-center p-2">
            <img src="/assets/img/pdf Logo.png" alt="/" />
          </div>

          <!-- DINING INFO -->

          <div >
            Dine at <strong>Gulmohar</strong>, our all-day buffet-style vegetarian restaurant,
            offering fresh delicacies,
            <br />Jain selections and chef’s specials daily.
            Or savour <strong>Gourmet Street</strong>, featuring flavourful street-food delights.
          </div>


          <!-- OFFERS -->

          <h5 class=" fw-bold mt-3 mb-2" style=" color: #9b5c0d; border-bottom: 1px solid #9b5c0d; display: inline-block; ">EXPLORE OUR OFFERS</h5>
          <h5 class="fw-bold" style=" color: #9b5c0d ">DIWALI GATEWAY 2025</h5>
          <div class="text-sm mt-1">
            Experience our <strong>Diwali Getaway</strong> at ₹29,999/- from 19 to 26 Oct 2025.
            Includes buffet meals, cocktails, 20% dining discount, vibrant DJ nights,
            and complimentary game round for two. Savour an extra lunch at Glumohar,our elegant
            all-day vegetarian restaurant, for ₹999++.
          </div>
        </div>

        <!-- FOOTER -->

        <hr />
        <div class=" text-center">
          <div>
            {{Address}}
          </div>
          <div>
            Phone: {{HotelPhone}} , {{HotelMobile}} | Email: {{HotelEmail}}
          </div>
        </div>
      </div>
</body>
</html>
`;

  useEffect(() => {
    if (!editorRef.current) return;

    const toolbarOptions = [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      ["link", "image", "video"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["clean"],
    ];

    quillRef.current = new Quill(editorRef.current, {
      theme: "snow",
      modules: { toolbar: toolbarOptions },
    });

    const saved = localStorage.getItem("voucherContent");
    quillRef.current.clipboard.dangerouslyPasteHTML(saved || initialHTML);

    /// image resize
    const makeImageResizable = (img) => {
      img.style.cursor = "nwse-resize";

      let startX, startY, startW, startH;

      const mousedown = (e) => {
        e.preventDefault();

        quillRef.current.root.querySelectorAll("img").forEach((i) => {
          i.style.border = "none";
        });

        img.style.border = "2px solid #0d6efd";
        img.style.borderRadius = "4px";

        startX = e.clientX;
        startY = e.clientY;
        startW = img.offsetWidth;
        startH = img.offsetHeight;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };

      const mousemove = (e) => {
        const newWidth = startW + (e.clientX - startX);
        const newHeight = startH + (e.clientY - startY);

        const ratio = startW / startH;
        if (newWidth / newHeight > ratio) {
          img.style.width = newWidth + "px";
          img.style.height = newWidth / ratio + "px";
        } else {
          img.style.width = newHeight * ratio + "px";
          img.style.height = newHeight + "px";
        }
      };

      const mouseup = () => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
      };

      img.addEventListener("mousedown", mousedown);
    };

    const initImages = () => {
      const imgs = quillRef.current.root.querySelectorAll("img");
      imgs.forEach((img) => {
        if (!img.dataset.resizable) {
          img.dataset.resizable = "true";
          makeImageResizable(img);
        }
      });
    };

    initImages();

    quillRef.current.on("text-change", initImages);
  }, []);

  const handleSave = () => {
    localStorage.setItem("voucherContent", quillRef.current.root.innerHTML);
    alert("Saved!");
  };

  // ⭐⭐⭐ 100% Working Modal Preview, No Popup, No Block
  const handlePreview = () => {
    const html = quillRef.current.root.innerHTML;

    const finalHTML = `
      <html>
        <head>
          <link rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
          />
          <style>
            body { background:#fff; padding:20px; font-family:Arial; }
            img { max-width:100%; height:auto; }
          </style>
        </head>
        <body>${html}</body>
      </html>
    `;

    const iframe = document.getElementById("previewFrame");
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(finalHTML);
    iframe.contentWindow.document.close();

    window.bootstrap.Modal.getOrCreateInstance(
      document.getElementById("previewModal")
    ).show();
  };

  return (
    <div className="wrapper">
      <SideBar />
      <div className="main-panel">
        <Hearder />

        <div className="container">
          <div className="page-inner">
            <h3>Voucher Editor</h3>

            <div
              ref={editorRef}
              style={{ height: "400px", background: "#fff", padding: "8px" }}
            ></div>

            <div className="text-end mt-3 d-flex justify-content-end gap-2">
              <button className="btn btn-secondary" onClick={handlePreview}>
                Preview
              </button>
              <button className="btn btn-primary" onClick={handleSave}>
                Save Content
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ⭐ Preview Modal ⭐ */}
      <div className="modal fade" id="previewModal" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Voucher Preview</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body" style={{ height: "80vh" }}>
              <iframe
                id="previewFrame"
                style={{ width: "100%", height: "100%", border: "none" }}
              ></iframe>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={() =>
                  document.getElementById("previewFrame").contentWindow.print()
                }
              >
                Print
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoucherEdit;
